import { canGoBack, closeWebview } from '@kakaopay-common/payweb-bridge';

import { SCHEME } from '~/constants/SCHEME';

type Props = {
  shouldOpenDiscoveryTab?: boolean;
};

export const dynamicHistoryBack = async ({ shouldOpenDiscoveryTab }: Props) => {
  const { result, success } = await canGoBack();
  if (!result.can_go_back || !success) {
    shouldOpenDiscoveryTab
      ? (location.href = `kakaopay://${SCHEME.MTS_DISCOVERY}`)
      : closeWebview();
  } else {
    window.history.back();
  }
};
